import "./timeline.css";
import "./tech_icons.css";
import React, { useState } from "react";
import { Timeline2024 } from "./timeline_2024.js";
import { Timeline2025 } from "./timeline_2025.js";
import { Timeline2026 } from "./timeline_2026.js";
import { GitRepos } from "../lib/git-repos.js";

export function Timeline() {
const [openTimeline2026, setOpenTimeline2026] = useState(true);
const [openTimeline2025, setOpenTimeline2025] = useState(true);
  const [openTimeline2024, setOpenTimeline2024] = useState(false);
  const gitData = GitRepos();
  const coffeeRepoStars = gitData?.[2]?.stargazers_count ?? "___";

  return (
    <>
      <div className="timeline">
        <button
          className="header-dropdown"
          onClick={() => setOpenTimeline2026(!openTimeline2026)}
        >
          <h1>
            2026
            <div
              className="small-carrot"
              style={{
                display: "inline-block",
                transform: openTimeline2026 ? "rotate(90deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
                marginLeft: "8px",
                verticalAlign: "middle",
                overflow: "visible",
                transformOrigin: "center center", // Ensures rotation happens from center
                padding: "4px",
              }}
            >></div>
          </h1>
        </button>
        <Timeline2026 isOpen={openTimeline2026} />
        <button
          className="header-dropdown"
          onClick={() => setOpenTimeline2025(!openTimeline2025)}
        >
          <h1>
            2025
            <div
              className="small-carrot"
              style={{
                display: "inline-block",
                transform: openTimeline2025 ? "rotate(90deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
                marginLeft: "8px",
                verticalAlign: "middle",
                overflow: "visible",
                transformOrigin: "center center", // Ensures rotation happens from center
                padding: "4px",
              }}
            >></div>
          </h1>
        </button>
        <Timeline2025 isOpen={openTimeline2025} />
      <div>
        <button
          className="header-dropdown"
          onClick={() => setOpenTimeline2024(!openTimeline2024)}
        >
          <h1>
            2024
            <div
              className="small-carrot"
              style={{
                display: "inline-block",
                transform: openTimeline2024 ? "rotate(90deg)" : "rotate(0deg)",
                transition: "transform 0.3s ease",
                marginLeft: "8px",
                verticalAlign: "middle",
                overflow: "visible",
                transformOrigin: "center center", // Ensures rotation happens from center
                padding: "4px",
              }}
            >></div>
          </h1>
        </button>
        <Timeline2024 isOpen={openTimeline2024} data={coffeeRepoStars} />
      </div>
      </div>
    </>
  );
}
